import type { ClientCommentCreateRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentEventsApi } from '@/features/api/hooks/grapevine-comment-events/useGrapevineCommentEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useCreateComment = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineCommentEventsApi();

  return useApiMutation({
    mutationFn: (commentCreateRequest: ClientCommentCreateRequest) =>
      api.onCommentCreateRequest({
        clientCommentCreateRequest: commentCreateRequest
      }),
    onSuccess: (data) =>
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.COMMENTS, data.comment.postId]
      })
  });
};
